/**
 * ¿El "error" de esta mutation es en realidad el encolado offline del
 * `OfflineQueueLink`? (la op quedó persistida en `rois_offline_mutation_queue`
 * y se reproducirá al reconectar — para el usuario es un ÉXITO diferido).
 *
 * Extraído 2026-07-21 de los duplicados byte-idénticos de
 * `ChangeStateModal/index.tsx` y `EditRoute/action.ts` (plan
 * sr-offline-retry-parity T4) — única fuente para toda la app.
 */
export function isOfflineQueuedError(err: unknown): boolean {
  const e = err as {
    offlineQueued?: boolean;
    message?: string;
    networkError?: { offlineQueued?: boolean };
  };
  return (
    e?.offlineQueued === true ||
    e?.networkError?.offlineQueued === true ||
    (e?.message ?? '').includes('Mutation queued for offline sync')
  );
}

export const OFFLINE_QUEUED_MESSAGE = 'Mutation queued for offline sync';

/**
 * Centinela ÚNICO de «encolada sin red». Lo emite `OfflineQueueLink` (antes de
 * enviar, o al vencer el techo de espera) y el sondeo previo de los asistentes
 * que encolan por su cuenta (`NewRoute/saveData`). Un solo constructor para que
 * `isOfflineQueuedError` no tenga que reconocer dos formas.
 */
export function createOfflineQueuedError(
  extra?: { redirectTo?: string },
): Error & { offlineQueued: true; redirectTo?: string } {
  const error = new Error(OFFLINE_QUEUED_MESSAGE) as Error & {
    offlineQueued: true;
    redirectTo?: string;
  };
  error.offlineQueued = true;
  // Quien encola por su cuenta (fase 2 de la actuación, paso terminal del
  // accidente) sabe a dónde volver; el router action solo pone el toast y
  // redirige (spec 2026-09-08-fase2-encolada § 2 D9).
  if (extra?.redirectTo) error.redirectTo = extra.redirectTo;
  return error;
}
